import React, { useState } from "react";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";

import { ReactComponent as MenuSVG } from "../../../assets/menu.svg";
import { ReactComponent as PlusSVG } from "../../../assets/plus.svg";
import { ReactComponent as MinusSVG } from "../../../assets/minus.svg";
import { ReactComponent as RandomSVG } from "../../../assets/random.svg";
import { ReactComponent as HiSVG } from "../../../assets/hi.svg";
import { ReactComponent as LoSVG } from "../../../assets/lo.svg";
import currencies from '../../helpers/getCurrency'

import {
  OPDarkContainer,
  OPBox,
  OPHeader,
  OPDescription,
  OPDescriptionContainer,
  OPDescriptionBox,
  OPDescriptionIcon,
  OPDescriptionBigIcon,
  OPDescriptionSkipIcon,
  OParrows,
  MenuBox,
  OPWrapper,
} from "../settings/SettingsStyled";

export default ({ handleAbove, aboveAnim, handleAboveAnimation, audio, userInfo }) => {
  const { maxWin, curr } = userInfo
  const [closeBtn, setcloseBtn] = useState(false);
  const [soundPlayed, setSoundPlayed] = useState(false);

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };
  return (
    <OPDarkContainer aboveAnim={aboveAnim}>
      <OPWrapper>
        <OPBox aboveAnim={aboveAnim}>
          <OPHeader
            close={closeBtn}
            aboveAnim={aboveAnim}
            soundPlayed={soundPlayed}
          >
            <p>Game Rules</p>
            <span
              onClick={() => {
                setAnimation(closeBtn, setcloseBtn);
                audio();
                setSoundPlayed(true);
                setTimeout(() => {
                  handleAboveAnimation(false);
                  setTimeout(() => {
                    handleAbove(false);
                  }, 400);
                }, 150);
              }}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          <OPDescription>
            <h3>HILO</h3>
            <p>
              HILO is yet another revolutionary concept of simplicity developed
              by Orbital’s talented team. HILO is highly customizable, yet an
              extremely easy game, in which you can choose the odds as you see
              fit. All you have to do is guess the next card and bet on a higher
              or lower draw. The Ace is the lowest card and the King is the
              highest. If one of these 2 will be drawn, you can choose to bet on
              the Same card. Should you Win, you’ll get a significant profit.
            </p>
          </OPDescription>
          <OPDescription>
            <h3>Settings</h3>
            <OPDescriptionContainer>
              <MenuBox width="42px" height="42px">
                <MenuSVG />
              </MenuBox>
              <OPDescriptionBox>
                <p>Settings Button</p>
                <p>Press the button to access settings.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <p>
              <b> Provably Fair</b> – This section grants you the possibility of
              checking the fairness of the game for yourself. <br />
              <br />
              <b> Game Rules</b> – Short description of the game. <br />
              <br />
              <b> History </b>– Shows your previous plays and allows you to
              devise new tactics for your next shuffle. <br />
              <br />
              <b> Music</b> - Turn on the unique audio overlay of the game.{" "}
              <br />
              <br />
              <b> Sound </b> – Enable unique action sounds of the game. <br />
              <br />
              <b> Volume Bar </b> – Set the volume.
            </p>
          </OPDescription>
          <OPDescription>
            <h3>Gameplay Customization </h3>
            <p>
              <b>Play Button</b> – Start the game.
              <br />
              <br />
            </p>
            <OPDescriptionContainer>
              <OPDescriptionIcon>2X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>2x Button</p>
                <p>Doubles your bet instantly.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>1/2</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>1/2 Button</p>
                <p>Divides your bet by half.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionSkipIcon>
                <RandomSVG />
              </OPDescriptionSkipIcon>
              <OPDescriptionBox>
                <p>Skip Button</p>
                <p>Click on the skip button to shuffle it to the next one</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionBigIcon>
                <p>HI</p>
                <p>00.00X</p>
              </OPDescriptionBigIcon>
              <OPDescriptionBox>
                <p>HI Button</p>
                <p>Bet on a higher card draw.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionBigIcon>
                <p>LO</p>
                <p>00.00X</p>
              </OPDescriptionBigIcon>
              <OPDescriptionBox>
                <p>LO Button</p>
                <p>Bet on a lower card draw.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionBigIcon>
                <p>SAME</p>
                <p>00.00X</p>
              </OPDescriptionBigIcon>
              <OPDescriptionBox>
                <p>SAME Button</p>
                <p>Bet on a same card sraw.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OParrows>
                - <span>=</span> <HiSVG />
                <LoSVG />
              </OParrows>
              <OPDescriptionBox>
                <p>Arrow Buttons</p>
                <p>
                  Indicates your previous bets (HIGH, LOW or SAME) and when you
                  click, it shows you the history and times of the current
                  continuous game
                </p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <p>
              <b>Click On Bet Amount</b> – Additional betting options.
              <br /> <br />
              Options: <br /> <br />
            </p>
            <OPDescriptionContainer>
              <OPDescriptionIcon>2X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>2x Button</p>
                <p>Doubles your bet instantly.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>1/2</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>1/2 Button</p>
                <p>Divides your bet by half.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>5X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>5x Button</p>
                <p>Multiply your bet by 5.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <PlusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>+ Button</p>
                <p>Increase amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <MinusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>- Button</p>
                <p>Decrease amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionBox>
              <p>*Max Win Amount is {maxWin}{currencies[curr]} for this game, win above this won't be added to your balance although you can play the game to try and win more for fun although only win amount you  will be awarded will not exceed max win amount.</p>
            </OPDescriptionBox>
          </OPDescription>
        </OPBox>
      </OPWrapper>
    </OPDarkContainer>
  );
};
